// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1mhkk","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2hyhF","obliqueLine":"membershipbadge_obliqueLine__3lsUi"};